module.exports = __webpack_public_path__ + "img/btn2-415x300.3d488bad.jpg";